import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";

export const fetchDoctorDashboardData = createAsyncThunk(
  "doctorDashboard/fetchDoctorDashboardData",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get("/clinic/dashboard/doctors");
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || "Failed to fetch doctor dashboard data"
      );
    }
  }
);

const doctorDashboardSlice = createSlice({
  name: "doctorDashboard",
  initialState: {
    activeVetCount: 0,
    activeOtherCount: 0,
    totalDoctorsOnHolidayToday: 0,
    weekConsultationCounts: [],
    monthlyConsultationCounts: [],
    yearlyConsultationCounts: [],
    top5VetsByCompletedAppointments: [],
    vetSpecial: [],
    serviceTypeGrowth: {},
    vetShif: [],
    utilizationVsCapacity: [],
    onTimeStartDelay: [],
    followUpContinuity: [],
    caseMixPerVet: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDoctorDashboardData.fulfilled, (state, action) => {
        state.loading = false;

        // General Dashboard Info
        state.activeVetCount = action.payload.activeVetCount || 0;
        state.activeOtherCount = action.payload.activeOtherCount || 0;
        state.totalDoctorsOnHolidayToday =
          action.payload.leaveDoctors?.totalDoctorsOnHolidayToday || 0;

        // Consultation Chart Data
        state.weekConsultationCounts =
          action.payload.weekConsultationCounts || [];
        state.monthlyConsultationCounts =
          action.payload.monthlyConsultationCounts || [];
        state.yearlyConsultationCounts =
          action.payload.yearlyConsultationCounts || [];

        // Top Vets by Appointments
        state.top5VetsByCompletedAppointments =
          action.payload.top5VetsByCompletedAppointments || [];

        // Vet Specializations
        state.vetSpecial = action.payload.vetSpecial || [];

        // Service Type Growth
        state.serviceTypeGrowth = action.payload.serviceTypeGrowth || {};

        // Vet Shift Schedule
        state.vetShif = action.payload.vetShif || []; // Save vet shift data

        state.utilizationVsCapacity =
          action.payload.utilizationVsCapacity || [];

        state.onTimeStartDelay = action.payload.onTimeStartDelay || [];
        state.followUpContinuity = action.payload.followUpContinuity || [];
        state.caseMixPerVet = action.payload.caseMixPerVet || {};
      })
      .addCase(fetchDoctorDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default doctorDashboardSlice.reducer;
